import React from 'react'
import style from './TitleSVG.module.css'

const TitleSVG = ({ Icon, titleHighlight, title }) => {
  return (
    <div>
      <div className={style.title_text}>
        {Icon && <Icon className={style.img_icon} />}
        <span>
          <span className={style.title_text_highlight}>{titleHighlight}</span>
          {title}
        </span>
      </div>
    </div>
  )
}

export default TitleSVG